import { LitElement, html } from "lit";
import { customElement, state } from "lit/decorators.js";
import { menuIcon, eyeOpenIcon, eyeClosedIcon } from "../utils/icons.js";
import { Store } from "../utils/store.js";

@customElement("dashboard-navbar-component")
export class DashboardNavBarComponent extends LitElement {
    @state() private blurEnabled = false;

    createRenderRoot() {
        return this;
    }

    connectedCallback() {
        super.connectedCallback();
        this.blurEnabled = Store.getSettings().blurSensitiveData ?? false;
    }

    private toggleBlur = () => {
        this.blurEnabled = !this.blurEnabled;
        Store.setSettings({
            ...Store.getSettings(),
            blurSensitiveData: this.blurEnabled,
        });
        // Dispatch a custom event so other components can react
        window.dispatchEvent(new CustomEvent("blur-toggle", { detail: { enabled: this.blurEnabled } }));
        this.requestUpdate();
    };

    render() {
        return html`
            <div class="navbar bg-base-100 shadow-sm lg:hidden flex justify-between items-center">
                <div class="flex items-center gap-2">
                    <label for="my-drawer" aria-label="Open Sidebar" class="btn btn-square btn-ghost">
                        <div class="w-6 h-6">${menuIcon}</div>
                    </label>
                    <img src="/logo.svg" alt="AppShovel Logo" class="w-8 h-8" />
                    <a class="text-3xl font-bold" href="/">AppShovel</a>
                </div>
                <button
                    class="btn btn-square btn-ghost"
                    @click=${(e: Event) => {
                        e.stopPropagation();
                        this.toggleBlur();
                    }}
                    aria-label="${this.blurEnabled ? "Disable blur mode" : "Enable blur mode"}"
                >
                    <div class="w-6 h-6">${this.blurEnabled ? eyeClosedIcon : eyeOpenIcon}</div>
                </button>
            </div>
        `;
    }
}
